import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { IoCloseOutline } from "react-icons/io5";

const Drawer = ({
  isOpen,
  onClose,
  closeBtn,
  title,
  children,
  align = "right",
}) => {
  useEffect(() => {
    const body = document.querySelector("body");

    if (isOpen) {
      body.classList.add("overflow-y-hidden");
    } else {
      body.classList.remove("overflow-y-hidden");
    }

    // Clean-up in case the component is unmounted
    return () => {
      body.classList.remove("overflow-y-hidden");
    };
  }, [isOpen]);
  // Determine motion and alignment styles based on the align prop
  const positionStyles = {
    top: "inset-x-0 top-0",
    right: "inset-y-0 right-0",
    bottom: "inset-x-0 bottom-0",
    left: "inset-y-0 left-0",
  };

  const initialStyles = {
    top: { y: "-100%", x: "0%" },
    right: { y: "50px", x: "100%" },
    bottom: { y: "100%", x: "0%" },
    left: { y: "0%", x: "-100%" },
  };

  const animateStyles = {
    top: { y: isOpen ? "0%" : "-100%", x: "0%" },
    right: { y: "50px", x: isOpen ? "0%" : "100%" },
    bottom: { y: isOpen ? "0%" : "100%", x: "0%" },
    left: { y: "0%", x: isOpen ? "0%" : "-100%" },
  };

  return (
    <div
      className={`fixed inset-0 z-[1001] ${
        isOpen ? "pointer-events-auto" : "pointer-events-none"
      }`}
    >
      {/* Overlay */}
      <div
        className={`absolute inset-0 transition-all ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      ></div>

      {/* Drawer Content */}
      <motion.div
        initial={initialStyles[align]}
        animate={animateStyles[align]}
        exit={initialStyles[align]}
        transition={{ duration: 0.3 }}
        className={`fixed bg-body w-full md:max-w-[540px] h-auto md:h-screen ${
          positionStyles[align]
        } ${isOpen ? "block" : "hidden"}`}
        // style={align === "top" || align === "bottom" ? { borderRadius: "8px 8px 0 0" } : { borderRadius: "0 8px 8px 0" }}
      >
        <div className="h-full p-2">
          <div className="flex justify-between">
            <h1 className="text-[#202020] text-[20px] lg:text-[24px] font-medium mb-4 pr-6 w-full">
              {title}
            </h1>
            {closeBtn && (
              <button
                className="self-start mb-4 text-gray-500 hover:text-gray-700 absolute right-4 top-5"
                onClick={onClose}
              >
                X
              </button>
            )}
          </div>
          {children}
        </div>
      </motion.div>
    </div>
  );
};

export default Drawer;
